import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BtnDarkMode from '../btnDarkMode/BtnDarkMode';
import LangSwitcher from '../langSwitcher/LangSwitcher';
import './style.css';
import { Bars3Icon } from '@heroicons/react/20/solid';
import logo from '../../img/logo.webp';

const Navbar = ({ openNav }) => {
  const { t } = useTranslation('common');
  const activeLink = 'nav-list__link nav-list__link--active';
  const normalLink = 'nav-list__link';

  return (
    <nav className="nav">
      <div className="container">
        <div className="nav-row">
          <NavLink to="/" className="logo-wrapper">
            {/* Decorative: the adjacent "PixelCraft" wordmark already
                identifies this link, so the icon needs no alt text. */}
            <img src={logo} alt="" width={30} height={30} className="logo-image" />
            <div className="logo">Pixel<strong>Craft</strong></div>
          </NavLink>

          <ul className="nav-list">
            {[
              { to: '/',         key: 'home' },
              { to: '/prices',   key: 'prices' },
              { to: '/design',   key: 'design' },
              { to: '/projects', key: 'projects' },
              { to: '/gallery',  key: 'gallery' },
              { to: '/contacts', key: 'contacts' },
            ].map(({ to, key }) => (
              <li key={key} className="nav-list__item">
                <NavLink
                  to={to}
                  className={({ isActive }) => isActive ? activeLink : normalLink}
                >
                  {t(`nav.${key}`)}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="nav-controls">
            <BtnDarkMode />
            <LangSwitcher />
          </div>

          <button onClick={openNav} className="nav__icon">
            <Bars3Icon />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
